const Menu = [
  { is_header: true, title: "CMMS" },
  {
    path: "/setup-center",
    icon: "bi bi-rocket-takeoff",
    title: "Setup Center",
  },
  {
    path: "/work-order/list",
    icon: "bi bi-people",
    title: "Work Order",
  },
  {
    path: "/request/list",
    icon: "bi bi-inbox",
    title: "Request",
  },

  { path: "/analytics", icon: "bi bi-bar-chart", title: "Analytics" },
  { path: "/assets/list", icon: "bi bi-boxes", title: "Assets Management" },
  {
    path: "/purchase-order/list",
    icon: "bi bi-file-check",
    title: "Purchase Order",
  },
  {
    path: "/parts",
    icon: "bi bi-gear",
    title: "Parts & Inventory",
    children: [
      { path: "/part/list", title: "Parts" },
      { path: "/part/inventory", title: "Inventory" },
    ],
  },

  {
    path: "/vendors",
    icon: "bi bi-buildings",
    title: "Vendor & Customer",
    children: [
      { path: "/vendor/management", title: "Vendor Management" },
      { path: "/customer/management", title: "Customer Management" },
    ],
  },
  {
    path: "/workers",
    icon: "bi bi-person",
    title: "People & Team",
    children: [
      { path: "/workers/people", title: "Workers / People" },
      { path: "/workers/teams", title: "Team" },
    ],
  },
  {
    path: "/setup",
    icon: "bi bi-gear",
    title: "Setup",
    children: [
      { path: "/setup/company", title: "Company Profile" },
      { path: "/setup/location", title: "Location" },
      { path: "/setup/roles", title: "Roles" },
      { path: "/checklist/list", title: "Tasks & Checklist Generation" },
      { path: "/setup/category", title: "Category / Type" },
      { path: "/import", title: "Import Data" },
      // { path: "/qrcode", title: "Print QR Code" },
    ],
  },
  // { path: '/helper', icon: 'bi bi-gem',	title: 'Helper' }
];

export default Menu;
